import React from "react";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { Button } from "antd";

export default function FullscreenControl({ isFullscreen, exitAction, enterAction }) {
  return isFullscreen ? (
    <Button icon={<FullscreenExitOutlined />} className="fullscreen-btn" onClick={exitAction} />
  ) : (
    <Button icon={<FullscreenOutlined />} className="fullscreen-btn" onClick={enterAction} />
  );
}
